import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setTVL } from "../../../redux/tokenSlice";
import cn from "classnames";
import styles from "./Tvl.module.sass";
import Icon from "../../Icon";
// import Item from "./Item";
// import Suggestion from "./Suggestion";
// import ModalProduct from "../../../components/ModalProduct";
import { DEFI_LLAMA_WISE_LENDING_INFO_LINK, ERROR_RWA_READ, rwaData, WISE_TVL_LINK } from "../../../utils/config";
import { _no, displayWithSkeleton, formatUSD } from "../../../utils";
import { setChainId } from "../../../redux/tokenSlice";
import { useAccount, useContractReads, useSwitchNetwork } from "wagmi";
// import useConfig from "../../../customHooks/useConfig";
import { arbitrum, mainnet } from "viem/chains";
import Tooltip from "../../Tooltip";

import useConfig from "../../../customHooks/useConfig";
import { formatUnits } from "viem";
import { ALL_SUPPORTED_POOLS, getSupportedTokens } from "../../../ethers/tokens";
import { getForwardingDepositContracts } from "../../../ethers/contracts";



const Tvl = ({ className }) => {
    const [visible, setVisible] = useState(false);
    const [tokens, setTokens] = useState([]);
    const [totalDeposited, setTotalDeposited] = useState(0);
    // const [visibleModalProduct, setVisibleModalProduct] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const dispatch = useDispatch();
    // const config = useConfig();
    const { isConnected } = useAccount();
    const {
        switchNetwork
    } = useSwitchNetwork();
    const config = useConfig();

    const {
        chainId,
    } = config;

    const { TVL } = useSelector((state) => state.token);

    const supportedTokens = useMemo(
        () => {
            return getSupportedTokens(
                chainId,
                ALL_SUPPORTED_POOLS
            );
        },
        [chainId]
    );

    useEffect(() => {
        const tokensToAdd = [];
        rwaData.forEach(data => {
            const token = supportedTokens.find(
                (token) => {
                    return token.name === data.defaultToken
                        && token?.isAavePool === (data.tokens?.[data.defaultToken]?.isAave ?? false)
                        && token?.isRWA === true;
                }
            );
            if (token) {
                tokensToAdd.push(token);
            }
        });
        setTokens(tokensToAdd);
    }, [supportedTokens]);

    const forwardingDepositContracts = useMemo(() => getForwardingDepositContracts('', true), []);

    useContractReads({
        contracts: forwardingDepositContracts.map(({ address, abi, chainId }) => ({
            chainId,
            address,
            abi,
            functionName: 'totalSupply',
            args: [],
        })),
        onError: (error) => console.error(ERROR_RWA_READ, error),
        onSuccess: (response) => {
            let totalDeposited = 0;
            response.forEach((totalDepositedData, index) => {
                const totalDepositedFormatted = formatUnits(
                    totalDepositedData.result ?? 0,
                    tokens.find(
                        (token) => token.name === forwardingDepositContracts[index].defaultToken
                    ).decimals
                );
                totalDeposited = totalDeposited + Number(totalDepositedFormatted);
            });
            setTotalDeposited(totalDeposited);
        },
    });
    
    useEffect(() => {
        const fetchTVL = async () => {
            try {
                const response = await axios.get(
                    WISE_TVL_LINK
                );
                dispatch(
                    setTVL(
                        response.data
                    )
                );
            } finally {
                setIsLoading(false);
            }
        }

        fetchTVL();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const totalSupplyWithDepositedValue = useMemo(() => {
        if (TVL?.totalSupplyValue && totalDeposited) {
            return Number(TVL?.totalSupplyValue) + Number(totalDeposited);
        }
        return TVL?.totalSupplyValue;
    }, [TVL?.totalSupplyValue, totalDeposited]);

    const tvlDisplay = displayWithSkeleton({
        isLoading,
        data: `TVL ${formatUSD(totalSupplyWithDepositedValue ?? 0)}`,
        isEmpty: _no(isLoading) && _no(TVL),
        skeletonWidth: '80%'
    });

    const handleSwitchNetworkArb = () => {
        handleSwitchNetwork(
            arbitrum.id
        );
    };

    const handleSwitchNetworkEth = () => {
        handleSwitchNetwork(
            mainnet.id
        );
    };

    const handleSwitchNetwork = (networkId) => {
        if (isConnected) {
            switchNetwork(
                networkId
            );
        } else {
            dispatch(
                setChainId(
                    networkId
                )
            );
        }
    };

    return (
        <>
            <div
                className={cn(
                    styles.Tvl,
                    className,
                    {
                        [styles.active]: visible
                    }
                )}
            >
                <div className={styles.head}>
                        <a
                            href={DEFI_LLAMA_WISE_LENDING_INFO_LINK}
                            target={"_blank"}
                            rel={"noreferrer"}
                        >
                            <Tooltip
                                title="Arbitrum + Ethereum Liquidity"
                                place="right"
                            >
                                <button className={styles.result}>{tvlDisplay}</button>
                            </Tooltip>
                        </a>
                        <input
                            className={styles.input}
                            type="text"
                            placeholder=""
                            onChange={() => setVisible(true)}
                        />
                    <img
                        className={styles.network}
                        onClick={handleSwitchNetworkArb}
                        src="/images/networks/arbitrum.svg"
                        alt="network icon"
                    >
                    </img>
                    <img
                        className={styles.networkEth}
                        onClick={handleSwitchNetworkEth}
                        src="/images/networks/ethereum.svg"
                        alt="network icon"
                    >
                    </img>
                </div>
                <button className={styles.close} onClick={() => setVisible(false)}>
                    <Icon name="close-circle" size="24" />
                </button>
            </div>
        </>
    );
};

export default Tvl;
